<div class="bg-white border m-2 py-3 px-3 shadow-sm">
  <h5>Unassign</h5>
  <p>
    <span class="text-warning text-bold">Remark:</span> when the device is unassigned all location and room based
    settings will be removed. The device should not be in an room anymore.
  </p>
  <button class="btn btn-warning me-2"
          (click)="unassign()">Unassign</button>
  <a class="btn btn-outline-primary"
     [routerLink]="['../']">Cancel</a>
</div>